import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import { Typography, Dialog } from "@mui/material";
import { useForm } from "react-hook-form";
import BaseApi from "../../../../functions/axios";
import { NormalBoldText } from "../../../../components/TextParts";
import NonIconButton from "../../../../components/NonIconButton";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ErrorMessage from "../atoms/errorMessage";

// バリデーションルール
const schema = yup.object({
  password: yup
    .string()
    .required("英字・数字を組み合わせた8文字以上のパスワードを入力してください")
    .min(8, "英字・数字を組み合わせた8文字以上のパスワードを入力してください")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&].*$/,
      "英字・数字を組み合わせた8文字以上のパスワードを入力してください"
    ),
  new_password: yup
    .string()
    .required("英字・数字を組み合わせた8文字以上のパスワードを入力してください")
    .min(8, "英字・数字を組み合わせた8文字以上のパスワードを入力してください")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&].*$/,
      "英字・数字を組み合わせた8文字以上のパスワードを入力してください"
    ),
  confirm: yup
    .string()
    .required("英字・数字を組み合わせた8文字以上のパスワードを入力してください")
    .min(8, "英字・数字を組み合わせた8文字以上のパスワードを入力してください")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&].*$/,
      "英字・数字を組み合わせた8文字以上のパスワードを入力してください"
    ),
});
export default function EditPasswordForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [isFailedToEditPassword, setIsFailedToEditPassword] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const handleClose = () => {
    setIsDialogOpen(false);
  };
  const onSubmit = async (data) => {
    console.log(errors);
    const params = new URLSearchParams();
    params.append("password", data.password);
    params.append("new_password", data.new_password);
    params.append("confirm", data.confirm);
    const res = await BaseApi.post("edit_password", params);
    console.log(res);
    if (res.data.result !== 0) {
      setIsFailedToEditPassword(true);
    } else {
      setIsFailedToEditPassword(false);
      setIsDialogOpen(true);
    }
  };
  return (
    <Container component="main" sx={{ p: 0 }}>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        maxWidth="300px"
        width="100%"
        sx={{ mx: "auto", my: "60px" }}
      >
        <Typography component={"span"}>
          <Box fontWeight="bold" sx={{ fontSize: 16 }}>
            パスワード
          </Box>
        </Typography>
        <TextField
          variant="standard"
          margin="normal"
          required
          type="password"
          {...register("password")}
          error={"password" in errors}
          // helperText={errors.password?.message}
          fullWidth
          name="password"
          // label="＊＊＊＊＊＊＊＊"
          id="password"
          autoComplete="current-password"
          sx={{
            bgcolor: "#ffffff",
            maxWidth: "300px",
            mt: "10px",
            mb: "40px",
          }}
          InputProps={{
            disableUnderline: true,
            fontSize: "14px",
            style: {
              padding: "20px",
            },
          }}
          InputLabelProps={{ shrink: true }}
        />
        <Typography component={"span"}>
          <Box fontWeight="bold" sx={{ fontSize: 16 }}>
            新しいパスワード
          </Box>
        </Typography>

        <TextField
          variant="standard"
          margin="normal"
          required
          type="password"
          {...register("new_password")}
          error={"password" in errors}
          fullWidth
          name="new_password"
          // label="＊＊＊＊＊＊＊＊"
          id="new_password"
          autoComplete="current-password"
          sx={{
            bgcolor: "#ffffff",
            maxWidth: "300px",
            mt: "10px",
            mb: "40px",
          }}
          InputProps={{
            disableUnderline: true,
            fontSize: "14px",
            style: {
              padding: "20px",
            },
          }}
          InputLabelProps={{ shrink: true }}
        />
        {errors.new_password?.message && (
          <ErrorMessage text={errors.new_password.message} />
        )}
        <Typography component={"span"}>
          <Box fontWeight="bold" sx={{ fontSize: 16 }}>
            新しいパスワード確認
          </Box>
        </Typography>

        <TextField
          variant="standard"
          margin="normal"
          required
          type="password"
          {...register("confirm")}
          error={"password" in errors}
          // helperText={errors.password?.message}
          fullWidth
          name="confirm"
          // label="＊＊＊＊＊＊＊＊"
          id="confirm"
          autoComplete="current-password"
          sx={{
            bgcolor: "#ffffff",
            maxWidth: "300px",
            mt: "10px",
            mb: "40px",
          }}
          InputProps={{
            disableUnderline: true,
            fontSize: "14px",
            style: {
              padding: "20px",
            },
          }}
          InputLabelProps={{ shrink: true }}
        />
        {errors.confirm?.message && (
          <ErrorMessage text={errors.confirm.message} />
        )}

        {isFailedToEditPassword && (
          <ErrorMessage text="パスワード変更に失敗しました。入力をご確認ください。" />
        )}
        <Button
          type="submit"
          variant="contained"
          onClick={() => {
            console.log(errors);
          }}
          fullWidth
          sx={{
            display: "block",
            maxWidth: 300,
            borderRadius: 25,
            bgcolor: "#29355a",
            "&:hover": {
              background: "#29355a",
            },
            py: "15px",
            my: "40px",
            mx: "auto",
          }}
        >
          <Typography
            sx={{ fontSize: 15 }}
            textTransform="none"
            fontWeight="bold"
          >
            変更
          </Typography>
        </Button>
      </Box>
      <Dialog onClose={handleClose} open={isDialogOpen}>
        <Box sx={{ width: "250px", height: "150px" }}>
          <Box sx={{ width: "200px", mx: "auto", my: "30px" }}>
            <Box sx={{ pb: "20px" }}>
              <NormalBoldText text="パスワードを変更しました。" />
            </Box>
            <NonIconButton clickEvent={handleClose} title="閉じる" />
          </Box>
        </Box>
      </Dialog>
    </Container>
  );
}
